import React from 'react';
import { Eyebrow, Button } from './UI';
import { Phone, Mail, Clock, MessageCircle } from 'lucide-react';
export const Contact = () => {
  return <section id="contact" className="relative py-[120px] overflow-hidden" data-id="element-1">
      {/* Background Video */}
      <div className="absolute inset-0 z-0" data-id="element-2">
        <video autoPlay={true} loop={true} muted={true} playsInline={true} className="w-full h-full object-cover opacity-100" data-id="element-3">
          <source src="https://cdn.magicpatterns.com/uploads/fWKrLziAYDyxUuYVynDRTi/hf_20260506_151534_e280cd37-1545-428a-a30c-8bf31ff2eab2.mp4" type="video/mp4" data-id="element-4" />
        </video>
        {/* Dark overlay to ensure text readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-base-black/90 via-base-black/40 to-base-black/90" data-id="element-5"></div>
        <div className="absolute inset-0 bg-patriot-navy/10 mix-blend-overlay" data-id="element-6"></div>
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-7">
        <div className="text-center mb-16" data-id="element-8">
          <Eyebrow data-id="element-9">DIRECT COMMS</Eyebrow>
          <h2 className="text-5xl md:text-[64px] leading-[0.9] mb-4" data-id="element-10">
            REACH THE{' '}
            <span className="text-acid-green" data-id="element-11">BLACKOUT UNIT TEAM.</span>
          </h2>
          <p className="font-barlow text-lg text-text-body max-w-2xl mx-auto" data-id="element-12">
            Real operators. Real answers. No bots. No wait. We respond to every
            single message.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-16" data-id="element-13">
          {/* Left - Info */}
          <div className="w-full lg:w-1/2" data-id="element-14">
            <p className="font-barlow text-[17px] text-text-body leading-[1.9] mb-10" data-id="element-15">
              "We're a team of operators and builders — not a faceless customer
              service department. When you contact BLACKOUT UNIT, a real person
              responds. Every time."
            </p>

            <div className="space-y-6 mb-10" data-id="element-16">
              <div className="flex items-start gap-4" data-id="element-17">
                <div className="w-12 h-12 border border-acid-green flex items-center justify-center text-acid-green shrink-0" data-id="element-18">
                  <Phone size={20} data-id="element-19" />
                </div>
                <div data-id="element-20">
                  <div className="font-barlow text-xs text-text-dimmed tracking-widest uppercase mb-1" data-id="element-21">
                    CALL DIRECT
                  </div>
                  <a href="tel:+18000000000" className="font-bebas text-2xl text-white hover:text-acid-green transition-colors" data-id="element-22">
                    +1 (800) 000-0000
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-23">
                <div className="w-12 h-12 border border-acid-green flex items-center justify-center text-acid-green shrink-0" data-id="element-24">
                  <Mail size={20} data-id="element-25" />
                </div>
                <div data-id="element-26">
                  <div className="font-barlow text-xs text-text-dimmed tracking-widest uppercase mb-1" data-id="element-27">
                    EMAIL SUPPORT
                  </div>
                  <a href="mailto:support@blackoutunit.com" className="font-bebas text-2xl text-white hover:text-acid-green transition-colors" data-id="element-28">
                    support@blackoutunit.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-29">
                <div className="w-12 h-12 border border-acid-green flex items-center justify-center text-acid-green shrink-0" data-id="element-30">
                  <Clock size={20} data-id="element-31" />
                </div>
                <div data-id="element-32">
                  <div className="font-barlow text-xs text-text-dimmed tracking-widest uppercase mb-1" data-id="element-33">
                    HOURS OF OPERATION
                  </div>
                  <div className="font-inter text-sm text-white" data-id="element-34">
                    Mon–Fri: 9AM–7PM ET
                    <br data-id="element-35" />
                    Saturday: 10AM–4PM ET
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-36">
                <div className="w-12 h-12 border border-acid-green flex items-center justify-center text-acid-green shrink-0" data-id="element-37">
                  <MessageCircle size={20} data-id="element-38" />
                </div>
                <div data-id="element-39">
                  <div className="font-barlow text-xs text-text-dimmed tracking-widest uppercase mb-1" data-id="element-40">
                    LIVE CHAT
                  </div>
                  <div className="font-inter text-sm text-white" data-id="element-41">
                    Available on this page — bottom right
                    <br data-id="element-42" />
                    <span className="text-text-dimmed" data-id="element-43">
                      Average response: under 3 minutes
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-[#4CAF50]/10 border border-[#4CAF50]/20 p-4 flex items-start gap-3" data-id="element-44">
              <div className="text-[#4CAF50] font-bold mt-0.5" data-id="element-45">✓</div>
              <div data-id="element-46">
                <div className="font-barlow font-bold text-xs text-[#4CAF50] tracking-[2px] uppercase mb-1" data-id="element-47">
                  AVERAGE RESPONSE TIME
                </div>
                <div className="font-inter text-xs text-text-dimmed" data-id="element-48">
                  "Under 2 hours during business hours. Same-day response
                  guaranteed Mon–Fri."
                </div>
              </div>
            </div>
          </div>

          {/* Right - Form */}
          <div className="w-full lg:w-1/2" data-id="element-49">
            <div className="bg-dark-1 border border-dark-3 p-8 md:p-10" data-id="element-50">
              <h3 className="font-bebas text-2xl text-white mb-6" data-id="element-51">
                SEND INTEL
              </h3>
              <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-52">
                <div className="grid grid-cols-2 gap-4" data-id="element-53">
                  <input type="text" placeholder="First Name" className="w-full bg-base-black border border-dark-3 p-3 text-white font-inter text-sm focus:border-acid-green outline-none transition-colors" data-id="element-54" />
                  <input type="text" placeholder="Last Name" className="w-full bg-base-black border border-dark-3 p-3 text-white font-inter text-sm focus:border-acid-green outline-none transition-colors" data-id="element-55" />
                </div>
                <input type="email" placeholder="Email Address" className="w-full bg-base-black border border-dark-3 p-3 text-white font-inter text-sm focus:border-acid-green outline-none transition-colors" data-id="element-56" />
                <input type="tel" placeholder="Phone (optional)" className="w-full bg-base-black border border-dark-3 p-3 text-white font-inter text-sm focus:border-acid-green outline-none transition-colors" data-id="element-57" />

                <div className="relative" data-id="element-58">
                  <select className="w-full bg-base-black border border-dark-3 p-3 text-text-dimmed font-inter text-sm focus:border-acid-green outline-none transition-colors appearance-none cursor-pointer" data-id="element-59">
                    <option value="" disabled selected data-id="element-60">
                      Select Subject...
                    </option>
                    <option value="order" data-id="element-61">Order Status</option>
                    <option value="product" data-id="element-62">Product Question</option>
                    <option value="warranty" data-id="element-63">Warranty Claim</option>
                    <option value="return" data-id="element-64">Return / Exchange</option>
                    <option value="wholesale" data-id="element-65">Wholesale Inquiry</option>
                    <option value="other" data-id="element-66">Other</option>
                  </select>
                  <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-text-dimmed" data-id="element-67">
                    ▼
                  </div>
                </div>

                <textarea placeholder="Message" rows={4} className="w-full bg-base-black border border-dark-3 p-3 text-white font-inter text-sm focus:border-acid-green outline-none transition-colors resize-none" data-id="element-68"></textarea>

                <Button variant="primary" fullWidth className="mt-4" data-id="element-69">
                  ⚡ SEND MESSAGE
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
};